import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.less';

const Loading = ({ full, small, className }) => (
  <div
    className={[
      styles.loading,
      full ? styles.full : null,
      small ? styles.small : null,
      className,
    ].join(' ')}
  >
    <img src="/static/images/loading.svg" alt="loading..." />
  </div>
);

Loading.propTypes = {
  full: PropTypes.bool,
  small: PropTypes.bool,
  className: PropTypes.string,
};

Loading.defaultProps = {
  full: false,
  small: false,
  className: '',
};

export default Loading;
